export function mapLanguages ({ countries }, country) {
    return countries[country.toUpperCase()].languages
}
